// TODO: Write the locale in BVVars and read it from there
import { locale } from 'state';

export default locale;
